export default function(value) {
  const containsAlphabet = /[a-zA-Z]/.test(value);
  const containsNumber = /[0-9]/.test(value);
  const containsSpecial = /[#?!@$%^&*-]/.test(value);
  return containsAlphabet && containsNumber && containsSpecial;
}
